import React from 'react';
import { path } from 'ramda';
import { Row, Col } from 'antd';
import styled from 'styled-components';
import { SendCommunicationSecondStepForm } from 'types';
import { FormikContextType } from 'formik';

import { useIntl } from 'common/config/i18n';
import FormError from 'components/molecules/form-error';
import Input from 'components/organisms/input';
import CardSendCommunication from 'components/molecules/card-send-communication';
import { KeywordsFormProvider } from 'components/organisms/input-keywords/keywords-context';

type Props = {
  formik: FormikContextType<SendCommunicationSecondStepForm>;
};

const Label = styled.div`
  font-size: ${path(['theme', 'font', 'size', 'caption'])};
`;

const EmailContextualization = ({ formik }: Props): React.ReactElement => {
  const { t } = useIntl();

  return (
    <KeywordsFormProvider>
      <CardSendCommunication title={t('form', 'NEW_TITLE')} style={{ marginBottom: '1rem' }}>
        <Row align="middle">
          <Col span={3}>
            <Label>{t('form', 'NEW_TITLE1')}</Label>
          </Col>
          <Col span={21}>
            <Input
              onChange={(text) => formik.handleChange({ target: { name: 'mailObject', value: text } })}
              value={formik.values.mailObject}
              name="mailObject"
              width="100%"
              maxLength={120}
              withKeywords
              autoSize
            />
            <FormError formik={formik} fieldName="mailObject" />
          </Col>
        </Row>

        <Row align="middle" style={{ marginTop: '1rem' }}>
          <Col span={3}>
            <Label>{t('form', 'NEW_TITLE2')}</Label>
          </Col>
          <Col span={21}>
            <Input
              onChange={formik.handleChange}
              value={formik.values.mailHeadband}
              name="mailHeadband"
              width="100%"
              maxLength={100}
            />
            <FormError formik={formik} fieldName="mailHeadband" />
          </Col>
        </Row>
      </CardSendCommunication>
    </KeywordsFormProvider>
  );
};

export default EmailContextualization;
